module.exports = __webpack_public_path__ + "img/icon1.2dc0230a.png";